var map = {
	"./0.png": "0b7c",
	"./1.png": "0922",
	"./10.png": "8ee7",
	"./11.png": "bba0",
	"./12.png": "455b",
	"./13.png": "00f0",
	"./14.png": "050e",
	"./15.png": "892b",
	"./16.png": "c158",
	"./17.png": "584f",
	"./18.png": "e11a",
	"./19.png": "dbb7",
	"./2.png": "05ce",
	"./20.png": "6251",
	"./21.png": "3813",
	"./22.png": "c183",
	"./23.png": "81c1",
	"./24.png": "7dbe",
	"./25.png": "bb35",
	"./26.png": "d450",
	"./27.png": "a622",
	"./28.png": "0506",
	"./29.png": "c80c",
	"./3.png": "f66f",
	"./30.png": "6aab",
	"./31.png": "6fe2",
	"./32.png": "f9f0",
	"./33.png": "768d",
	"./34.png": "bca1",
	"./35.png": "e67b",
	"./36.png": "8007",
	"./37.png": "1805",
	"./38.png": "cb23",
	"./39.png": "9f1a",
	"./4.png": "9e41",
	"./40.png": "e803",
	"./41.png": "b970",
	"./42.png": "1867",
	"./43.png": "eba5",
	"./44.png": "0148",
	"./45.png": "550e",
	"./46.png": "7b35",
	"./47.png": "778f",
	"./48.png": "8b30",
	"./49.png": "e037",
	"./5.png": "cca9",
	"./6.png": "1415",
	"./7.png": "051f",
	"./8.png": "b3ec",
	"./9.png": "cd5e",
	"./cachecol.png": "775e",
	"./chapeu.png": "dc30",
	"./flor.png": "bbab",
	"./oculos.png": "7e89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "86b2";